import { render, staticRenderFns } from "./GridWidget.vue?vue&type=template&id=10eb640b&scoped=true&"
import script from "./GridWidget.vue?vue&type=script&lang=js&"
export * from "./GridWidget.vue?vue&type=script&lang=js&"
import style0 from "./GridWidget.vue?vue&type=style&index=0&id=10eb640b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eb640b",
  null
  
)

export default component.exports